import { useState } from "react";
import { SectionCard, SectionCardTitle, Slider, SectionCardSubTitle } from "@/components";
import { slide } from "./consts";
import { Timeline } from "../Timeline";

const GrowthInnovation = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleYearClick = (year: string) => {
    const index = slide.findIndex((s) => s.year.replace(/[^0-9]/g, "") === year.replace(/[^0-9]/g, ""));
    if (index !== -1) setActiveIndex(index);
  };

  return (
    <section className="bg-blue-900 lg:pb-[100px] relative">
      <div className="hidden lg:block h-[130px] w-[130px] bg-primary rounded-full absolute bottom-10 right-15 float-animation" />

      <SectionCard className="bg-[url('/img/testimonials_bg.png')] bg-no-repeat bg-left bg-contain flex flex-col items-center justify-center text-white">
        <SectionCardSubTitle className="text-white mb-5">
          Intron Milestones
        </SectionCardSubTitle>
        <SectionCardTitle className="w-full lg:w-full mb-5">
          Our Journey of Growth and Innovation
        </SectionCardTitle>

        {/* Pass click handler */}
        <Timeline
          activeYear={slide[activeIndex].year}
          onYearClick={handleYearClick}
        />

        <Slider
          hideDots
          whiteNextPrevButton
          autoSlide
          slides={slide.map((data: any, index: number) => (
            <div
              key={index}
              className="w-full flex-shrink-0 px-4 sm:px-6 md:px-10 flex flex-col lg:flex-row items-center justify-center mt-10 lg:mt-15 gap-15 mb-10"
            >
              <div className="relative flex-shrink-0 flex justify-center">
                <div className="absolute -top-4 -left-4 w-full h-full border-4 border-[#d0e2e2] rounded-2xl lg:rounded-4xl pointer-events-none" />
                <img
                  src={data.image}
                  className="w-full max-w-[300px] sm:max-w-[400px] lg:max-w-[350px] h-auto rounded-xl relative z-10"
                  alt="Milestone"
                />
              </div>

              <div className="flex flex-col items-start justify-center text-white max-w-lg">
                {/* <h3 className="text-2xl sm:text-3xl lg:text-4xl mb-3">{data.year}</h3> */}
                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold">{data.title}</h3>
                <p className="mt-3 text-xs sm:text-sm leading-snug text-justify">{data.subtitle}</p>
              </div>
            </div>
          ))}
          activeIndex={activeIndex} // control slide
          onSlideChange={setActiveIndex}
        />
      </SectionCard>
    </section>
  );
};

export default GrowthInnovation;
